const DEFAULT_DATE_FORMAT = 'PP';
const API_DATE_FORMAT = 'yyyy-MM-dd';
const API_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
const CUSTOM_DATE_FORMAT = 'MM/dd/yyyy';
const FULL_DATE_FORMAT = "MMMM d, y 'at' p";

const DEFAULT_CURRENCY = 'USD';

const CAMPAIGN_MAIN_TYPE = 'cmp';
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

const DEFAULT_PAGE_SIZE = 20;

export {
  API_DATE_FORMAT,
  API_TIME_FORMAT,
  CAMPAIGN_MAIN_TYPE,
  CUSTOM_DATE_FORMAT,
  DEFAULT_CURRENCY,
  DEFAULT_DATE_FORMAT,
  DEFAULT_PAGE_SIZE,
  FULL_DATE_FORMAT,
  HOURS_IN_DAY,
  MINUTES_IN_HOUR,
};
